import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance, { isAxiosError } from "@/utils/axiosInstance";
import { Params } from "@/types";
import { handleThunkError } from "@/utils/thunkErrorHandler";

const endpoint = {
  products: "/products",
  saleEmployee: "/products/sale-employee",
};

export const fetchProducts = createAsyncThunk(
  "products/fetchProducts",
  async (params: Params, thunkAPI) => {
    try {
      const response = await axiosInstance.get(endpoint.products, { params });
      return response.data;
    } catch (error) {
      return handleThunkError(
        error,
        thunkAPI,
        "Não foi possível carregar os pacotes",
      );
    }
  },
);

export const createProduct = createAsyncThunk(
  "products/createProduct",
  async (data: any, thunkAPI) => {
    try {
      const isFormData =
        typeof FormData !== "undefined" && data instanceof FormData;
      const response = await axiosInstance.post(endpoint.products, data, {
        headers: isFormData
          ? { "Content-Type": "multipart/form-data" }
          : undefined,
      });
      return response.data;
    } catch (error) {
      return handleThunkError(
        error,
        thunkAPI,
        "Não foi possível cadastrar produto",
      );
    }
  },
);

export const updateProduct = createAsyncThunk(
  "products/updateProduct",
  async (data: any, thunkAPI) => {
    try {
      const { slug, ...rest } = data;
      const payload = (rest as any).data ? (rest as any).data : rest;
      const isFormData =
        typeof FormData !== "undefined" && payload instanceof FormData;
      const response = await axiosInstance.put(
        `${endpoint.products}/${slug}`,
        payload,
        {
          headers: isFormData
            ? { "Content-Type": "multipart/form-data" }
            : undefined,
        },
      );
      return response.data;
    } catch (error) {
      return handleThunkError(
        error,
        thunkAPI,
        "Não foi possível atualizar produto",
      );
    }
  },
);

export const deleteProduct = createAsyncThunk(
  "products/deleteProduct",
  async (slug: string, thunkAPI) => {
    try {
      const response = await axiosInstance.delete(
        `${endpoint.products}/${slug}`,
      );
      return response.data;
    } catch (error) {
      return handleThunkError(
        error,
        thunkAPI,
        "Não foi possível carregar os pacotes",
      );
    }
  },
);

export const createSellEmployeeProducts = createAsyncThunk(
  "products/createSellEmployeeProducts",
  async (data: any, thunkAPI) => {
    try {
      const response = await axiosInstance.post(endpoint.saleEmployee, data);
      return response.data;
    } catch (error) {
      return handleThunkError(
        error,
        thunkAPI,
        "Não foi possível carregar os pacotes",
      );
    }
  },
);

export const uploadProductImage = createAsyncThunk(
  "products/uploadProductImage",
  async ({ slug, image }: { slug: string; image: File }, thunkAPI) => {
    try {
      const formData = new FormData();
      formData.append("image", image);
      const response = await axiosInstance.post(
        `${endpoint.products}/${slug}/upload-image`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );
      return response.data;
    } catch (error) {
      return handleThunkError(
        error,
        thunkAPI,
        "Não foi possível enviar imagem do produto",
      );
    }
  },
);
